/**
 *
 * AnalysisSegment
 *
 */

import "./index.less"

import {
  COMPARATIVE_ANALYSIS,
  COMPARATIVE_ANALYSIS_TEAM,
  DISABLE,
  ENABLE,
} from "../../../../../utils/constants"
import { Empty, Spin } from "antd"
import React, { Fragment } from "react"

import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import TeamList from "components/TeamList"
import { compose } from "redux"
import { connect } from "react-redux"
import emptyImg from "images/emptySegment.svg"
import { isEmpty } from "lodash"
import { isLeader, isModeInModuleBySlug } from "../../../../../utils/storage"
import { loadTexts } from "../../../../../utils/i18n"
import { PageView } from "../../../../../components/Snowplow/config2"

/* eslint-disable react/prefer-stateless-function */
export class AnalysisSegment extends React.Component {
  intlWidgetAnalysisSegment = loadTexts("reports_general_view").reportAmbassador
    .engagementMeasurement.widgetAnalysisSegment

  renderButtonRedirect(urlRedirect) {
    const { ranks } = this.props
    return (
      <div className="AnalysisSegment-header">
        <div className="AnalysisSegment-header-btn-link">
          <span>
            {Array.isArray(ranks) && ranks.length > 0 && (
              <Link to={urlRedirect} onClick={() =>
                PageView("Comparativo por grupos - Ir a análisis comparativo",
                null,
                null)
              }>
                {this.intlWidgetAnalysisSegment.link}
              </Link>
            )}
          </span>
        </div>
      </div>
    )
  }

  redirectComparativeAnalysis() {
    const {
      ranks,
      view_leader,
      measure,
      ambassadorDivisionSelected,
      idParentDivision,
      selectedSegment,
    } = this.props
    const showContent = Array.isArray(ranks) && ranks[0] && !ranks[0].empty
    if (!showContent) {
      return <div />
    }
    const isAmbassador = ambassadorDivisionSelected
      ? `?id_division=${ambassadorDivisionSelected}`
      : ""

    let segment = ""

    if (selectedSegment) {
      if (isAmbassador != "") {
        segment = `&id_segment=${selectedSegment}`
      } else {
        segment = `?id_segment=${selectedSegment}`
      }
    }

    const searchLocation = getUrlParams(location.search)
    let paramsPath = { ...searchLocation }
    let parentDivision = ""
    if (idParentDivision && !isEmpty(idParentDivision.toString())) {
      parentDivision =
        isEmpty(paramsPath.id_divisionParent) ||
        paramsPath.id_divisionParent === undefined
          ? (idParentDivision && isEmpty(idParentDivision.toString())) ||
            idParentDivision === undefined
            ? ""
            : `&id_divisionParent=${idParentDivision}`
          : `&id_divisionParent=${searchLocation.id_divisionParent}`
    }
    const modeComparativeAnalysis = isModeInModuleBySlug(COMPARATIVE_ANALYSIS)
    if (modeComparativeAnalysis !== DISABLE && !view_leader) {
      return this.renderButtonRedirect(
        `/reports/measure/${measure}/analysis-comparative${isAmbassador}${parentDivision}${segment}`
      )
    }
    const modeComparativeAnalysisTeam = isModeInModuleBySlug(
      COMPARATIVE_ANALYSIS_TEAM
    )
    if (modeComparativeAnalysisTeam !== DISABLE && view_leader) {
      return this.renderButtonRedirect(
        `/reports/measure/${measure}/teams/analysis-comparative${segment}`
      )
    }
    return <div />
  }

  renderContent() {
    const { ranks, view_leader, isLoading } = this.props
    const showContent = Array.isArray(ranks) && ranks[0] && !ranks[0].empty
    if (isLoading) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }

    return (
      <Fragment>
        {this.redirectComparativeAnalysis()}
        <div
          className="AnalysisSegment-body"
          style={
            Array.isArray(ranks) && ranks[0] && ranks[0].empty
              ? { gridTemplateColumns: "auto" }
              : {}
          }>
          {showContent ? (
            <Fragment>
              <TeamList
                view_leader={view_leader}
                list={ranks[0].segments_top}
                title={
                  view_leader
                    ? this.intlWidgetAnalysisSegment.leadersTop
                    : this.intlWidgetAnalysisSegment.segmentsTop
                }
              />
              <TeamList
                view_leader={view_leader}
                list={ranks[0].segments_low}
                title={
                  view_leader
                    ? this.intlWidgetAnalysisSegment.leadersBottom
                    : this.intlWidgetAnalysisSegment.segmentsLow
                }
              />
            </Fragment>
          ) : (
            <Empty
              style={{ color: "#828282" }}
              image={emptyImg}
              description={
                <span
                  style={{
                    margin: "0 auto",
                    maxWidth: 440,
                    display: "block",
                  }}>
                  {this.intlWidgetAnalysisSegment.empty}
                </span>
              }
              className="ReportsHome-empty-fix"
            />
          )}
        </div>
      </Fragment>
    )
  }

  render() {
    return (
      <div className="boxShadow AnalysisSegment ">
        <h4>{this.intlWidgetAnalysisSegment.title}</h4>
        <div className="AnalysisSegment">{this.renderContent()}</div>
      </div>
    )
  }
}

AnalysisSegment.propTypes = { dispatch: PropTypes.func.isRequired }

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(AnalysisSegment)
